import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import VLFCard from "@/components/Card";
import VLFDatePicker from "@/components/Input/DatePicker";
import MainActions from "@/components/MainActions";
import CardsContainer from "@/components/CardsContainer";
import CardsTable from "@/components/CardsTable";
import HandlePlayersDataModal from "./handlePlayersData";

import {RosterAPI} from "@/api/roster";
import {visibleRosters} from "@/utils/functions";

import AddIcon from "@mui/icons-material/Add";

import {getInternalClubId} from "@/utils/constants";
import {useCategories, usePlayers} from "@/utils/hooks";

import "./index.scss";

function AnthropometricDataPage(props) {
	const {currentDate, setCurrentDate, playersList, setPlayersList} = props;

	const {categories} = useCategories({
		setLoading: false,
		handleNotification: undefined,
		formatted: true,
	});

	const {players} = usePlayers({
		setLoading: false,
		handleNotification: undefined,
		goalkeepers: false,
		onlyInternal: true,
		prospect: false,
	});

	const seasonId = useSelector((state) => state?.season?.id);

	const [internalTeams, setInternalTeams] = useState([]);
	const getTeams = async () => {
		try {
			const response = await RosterAPI.list({seasonId, prospect: false, clubId: getInternalClubId()});
			setInternalTeams(
				visibleRosters(
					(response || []).filter((r) => !r.clubId || r.clubId === getInternalClubId()),
				),
			);
		} catch (error) {
			console.log(error);
		}
	};
	useEffect(() => {
		if (seasonId) {
			getTeams();
		}
	}, [seasonId]);

	const [openModal, setOpenModal] = useState(false);
	const [initialData, setInitialData] = useState();

	const columns = [
		{
			label: "Giocatore",
			key: "player",
			customRender: (item) => {
				return item.player?.label;
			},
		},
		{
			label: "Altezza",
			key: "height",
			customRender: (item) => {
				return item.height ? item.height + " cm" : "---";
			},
			medium: true,
		},
		{
			label: "Altezza seduto",
			key: "sittingHeight",
			customRender: (item) => {
				return item.sittingHeight ? item.sittingHeight + " cm" : "---";
			},
			medium: true,
		},
		{
			label: "Peso",
			key: "weight",
			customRender: (item) => {
				return item.weight ? item.weight + " kg" : "---";
			},
			medium: true,
		},
	];

	return (
		// <Page>
		// 	<Loading visible={loading} />
		// 	<Breadcrumbs actions={<MainActions actions={mainActions} />} />
		<div className="sheet-container">
			<div className="row">
				<div className="col-12">
					<VLFCard
						openable={false}
						content={
							<div className="row no-margin">
								<div className="col-12 col-md-4 padding-small">
									<VLFDatePicker
										label="Data"
										value={currentDate}
										onChange={setCurrentDate}
										required
									/>
								</div>
							</div>
						}
					/>
				</div>
			</div>
			<div className="row mt-2">
				<div className="col-12">
					<VLFCard
						title="Dati antropometrici"
						openable={false}
						content={
							<>
								<div className="main-actions-bar">
									<MainActions
										actions={[
											{
												icon: <AddIcon />,
												label: "Aggiungi giocatori",
												onClick: () => setOpenModal(true),
											},
										]}
									/>
								</div>
								<CardsContainer
									tableComponent={
										<CardsTable
											fullHeight={false}
											configurationColumns={columns}
											data={playersList}
											rowActions
											handleEdit={(item) => {
												setInitialData(Object.assign({}, item));
												setOpenModal(true);
											}}
											handleDelete={(item) => {
												const updatedList = Array.from(playersList);
												const index = updatedList.findIndex(
													(element) =>
														element.player.value === item.player.value,
												);
												updatedList.splice(index, 1);
												setPlayersList(updatedList);
											}}
										/>
									}
									listComponent={
										// <CardsList
										// 	type="scouting_report"
										// 	breadcrumbs={breadcrumbs}
										// 	grouped={grouped}
										// 	filtersData={filters || undefined}
										// 	listConfiguration={listConfiguration}
										// 	defaultGroupSortedOrder="descend"
										// />
										<></>
									}
								/>
							</>
						}
					/>
				</div>
			</div>
			{openModal ? (
				<HandlePlayersDataModal
					open={openModal}
					confirm={(values) => {
						if (initialData) {
							const updatedList = Array.from(playersList);
							const index = updatedList.findIndex(
								(item) => item.player.value === values.player.value,
							);
							updatedList[index] = {
								...updatedList[index],
								...values,
							};
							setPlayersList(updatedList);
						} else {
							if (values.player) {
								setPlayersList([...playersList, values]);
							}

							if (values.players) {
								const multiplePlayers = [];
								Object.keys(values.players)?.forEach((pk) => {
									if (values.players[pk].height || values.players[pk].weight) {
										multiplePlayers.push(values.players[pk]);
									}
								});
								setPlayersList([...playersList, ...multiplePlayers]);
							}
						}

						setOpenModal(false);
						setInitialData(undefined);
					}}
					close={() => {
						setOpenModal(false);
						setInitialData(undefined);
					}}
					initialData={initialData}
					categories={categories}
					teams={internalTeams}
					players={players?.filter((p) => {
						const isAlreadyPresent = playersList?.filter(
							(p2) => p2.player.value === p.id,
						)?.[0];
						return !isAlreadyPresent;
					})}
				/>
			) : null}
		</div>
		// </Page>
	);
}

export default AnthropometricDataPage;
